import axios from "axios";

axios.defaults.baseURL = process.env.VUE_APP_ROOT_API;

const state = {
  token: localStorage.getItem("access_token") || null,
  refresh_token: localStorage.getItem("refresh_token") || null,
  permissions: JSON.parse(localStorage.getItem("permissions")) || null,
  general_permissions:
    // JSON.parse(localStorage.getItem("general_permissions")) || null
    JSON.parse(localStorage.getItem("permissions")) || null
};

const getters = {
  loggedIn(state) {
    return state.token !== null;
  },
  generalPermissions(state) {
    return state.general_permissions;
  },
  sitePermissions(state) {
    return state.permissions;
  }
};

const actions = {
  retrieveToken(context, credentials) {
    return new Promise((resolve, reject) => {
      axios
        .post("auth/login", {
          username_or_email: credentials.username_or_email,
          password: credentials.password
        })
        .then(response => {
          const token = response.data.access_token;
          const refresh_token = response.data.refresh_token;

          localStorage.setItem("access_token", token);
          localStorage.setItem("refresh_token", refresh_token);
          context.commit("retrieveToken", token);
          context.commit("retrieveRefreshToken", refresh_token);
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  destroyToken(context) {
    if (context.getters.loggedIn) {
      return new Promise((resolve, reject) => {
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        localStorage.removeItem("permissions");
        localStorage.removeItem("general_permissions");
        context.commit("destroyToken");
        context.commit("destroyRefreshToken");
        context.commit("destroyUserPermissions");
        context.commit("destroyUserGeneralPermissions");
        resolve();
      });
    }
  },
  refreshToken(context) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          "auth/refresh",
          {},
          {
            headers: {
              Authorization: "Bearer " + context.state.refresh_token
            }
          }
        )
        .then(response => {
          const token = response.data.access_token;

          localStorage.setItem("access_token", token);
          context.commit("retrieveToken", token);
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  retrieveUserPermissions(context) {
    ///api/v1/user/permissions   // changing for now
    return new Promise((resolve, reject) => {
      axios
        .get("/api/v1/user/permissions", {
          headers: {
            Authorization: "Bearer " + context.state.token
          }
        })
        .then(response => {
          const permissions = response.data;
          localStorage.setItem("permissions", JSON.stringify(permissions));
          context.commit("retrieveUserPermissions", permissions);
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  retrieveUserGeneralPermissions(context) {
    return new Promise((resolve, reject) => {
      axios
        .get("api/v1/user/additional-permission/list", {
          headers: {
            Authorization: "Bearer " + context.state.token
          }
        })
        .then(response => {
          const result = response.data.results;
          var generalPermissions = [];
          for (let row of result) {
            generalPermissions.push(row.name);
          }
          // localStorage.setItem('general_permissions', JSON.stringify(generalPermissions))
          context.commit("retrieveUserGeneralPermissions", generalPermissions);
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  }
};

const mutations = {
  retrieveToken(state, token) {
    state.token = token;
  },
  destroyToken(state) {
    state.token = null;
  },
  retrieveRefreshToken(state, token) {
    state.refresh_token = token;
  },
  destroyRefreshToken(state) {
    state.refresh_token = null;
  },
  retrieveUserPermissions(state, permissions) {
    state.permissions = permissions;
  },
  destroyUserPermissions(state) {
    state.permissions = null;
  },
  retrieveUserGeneralPermissions(state, permissions) {
    state.general_permissions = permissions;
  },
  destroyUserGeneralPermissions(state) {
    state.general_permissions = null;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
